import * as requestFromServer from "./countryCrud";
import {countrySlice, callTypes} from "./countrySlice";

const {actions} = countrySlice;

export const listCountry=()=>dispatch => {

  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer.listCountry()
    .then(response => {
      console.log("i am heregggg",response.data);
      const {data } = response.data;
      const totalCount=data.length;
            console.log('I am testing',data,totalCount);
       dispatch(actions.countryFetched({entities:data,totalCount}));
    })
    .catch(error => {
      console.log('Iam inside error',error);
      error.clientMessage = "Can't find Country";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};
export const createCountry=country=>dispatch => {
console.log('heehee',country);
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer.createCountry(country)

    .then(response => {
      console.log("i am Conntry",response);
      const {data } = response.data;
      const totalCount=data.length;
            console.log('I am testing',data,totalCount);
       dispatch(actions.countryCreated({entities:data,totalCount}));
    })
    .catch(error => {
      console.log('Iam inside error',error);
      error.clientMessage = "Can't find Country";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};